import { render, staticRenderFns } from "./LazyImage.html?vue&type=template&id=1f5cbc5c&scoped=true&"
import script from "./LazyImage.ts?vue&type=script&lang=ts&"
export * from "./LazyImage.ts?vue&type=script&lang=ts&"
import style0 from "./LazyImage.scss?vue&type=style&index=0&id=1f5cbc5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5cbc5c",
  null
  
)

export default component.exports